<template>
<!-- eslint-disable -->
  <page-layout
    :breadcrumbs="[
      {
        text: 'HOME',
        exact: true,
        to: { name: 'home' }
      },
      {
        text: 'CANCELACIÓN',
        disabled: true
      }
    ]"
    titulo="CANCELACIÓN"
  >
    <v-row v-if="!cancelado && bajaTramitada" align-content="center" justify="center" style="min-height: 400px">
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <v-col cols="12" class="text-sm-center">
            Este número ya ha sido dado de baja
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-else-if="!cancelado" align-content="center" justify="center" style="min-height: 400px">
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <v-col cols="12" class="text-sm-center">
            Las formas de darse de baja del servicio son:
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12" style="background-color: #363636">
          <v-card-text>
            <v-row class="pb-0" justify="center">
              <v-col cols="12" class="text-xs-center">
                Baja automática pulsando en el siguiente botón
              </v-col>
              <v-btn dark color="viralYellow primary--text" :disabled="waiting" :loading="waiting" @click="doUnsubscribeMsisdn()">
                Baja
              </v-btn>
            </v-row>
            <!-- <v-row v-else class="pb-0" justify="center">
              <v-col cols="12">
                <v-form v-model="valid" ref="form">
                  <v-text-field
                    label="Introduzca su número de telefono para realizar la baja"
                    :rules="[rules.required, rules.max(256)]"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="msisdn"
                  />
                </v-form>
              </v-col>
              <v-btn dark color="viralYellow primary--text" :disabled="waiting" :loading="waiting" @click="doUnsubscribeMsisdn()">
                Baja
              </v-btn>
            </v-row> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-row class="pb-0">
          <v-col cols="12" class="text-sm-center">
            También puedes cancelar tu suscripción a través de:
          </v-col>
          <v-col cols="12" class="text-sm-center">
            email: soporte.mocabi@atencionalusuario.es
          </v-col>
          <v-col cols="12" class="text-sm-center">
            Teléfono no sobretarificado: 919100813
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-else align-content="center" justify="center" style="min-height: 400px">
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <v-col cols="12" class="text-sm-center" style="font-style: bold">
            SUSCRIPCIÓN A VIRALMOBILE CANCELADA CON ÉXITO
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <v-col cols="12" class="text-sm-center">
            Recibirá un sms de confirmación en su teléfono móvil.
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <v-col cols="12" class="text-sm-center">
            Recuerde que puede disfrutar del servicio durante su periodo pagado.
          </v-col>
        </v-row>
      </v-col>
      <v-btn dark color="viralYellow primary--text" @click="$router.push({name: 'home'})">
        IR A HOME
      </v-btn>
    </v-row>
  </page-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/mixins/rules'
import PageLayout from '../components/layouts/PageLayout.vue'
export default {
  components: { PageLayout },
  mixins: [rulesMixin],
  data() {
    return {
      valid: false,
      waiting: false,
      cancelado: false,
      enrichment: false,
      msisdn: ''
    }
  },
  async mounted() {
    const params = this.$route.query
    try {
      if (params.status === 'OK') {
        this.enrichment = true
        await this.mLoginApn(params)
        return
      } else if (params.status === 'ERROR') {
        // devolvemos si viene el status en 'ERROR' para que no intente hacer el enrichment todo el rato
        this.enrichment = false
        return
      }
    } catch (error) {
      // devolvemos si falla el loginApn para que no intente hacer el enrichment todo el rato
      this.enrichment = false
      return
    }
    if (this.accesoVip && !this.bajaTramitada) {
      try {
        this.waiting = true
        this.enrichment = true
        await this.enrichmentUnsubscribe()
        this.waiting = false
        return
      } catch (e) {
        this.enrichment = false
        this.waiting = false
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user',
      cookie: 'login/cookie',
      bajaTramitadaStore: 'login/bajaTramitada'
    }),
    bajaTramitada() {
      return this.bajaTramitadaStore || (this.user.status == 'DELETED' && this.user.lastBillingStatus == 'ERROR')
    },
    accesoVip() {
      return localStorage.getItem('login') === 'vip'
    },
    operationId() {
      return this.cookie('operationId')
    },
    correlationId() {
      return this.cookie('correlationId')
    }
  },
  methods: {
    ...mapActions({
      enrichmentUnsubscribe: 'login/enrichmentUnsubscribe',
      unsubscribe: 'login/unsubscribe',
      unsubscribeAuto: 'login/unsubscribeAuto',
      loginApn: 'login/loginApn',
      addAlert: 'alerts/add'
    }),
    async mLoginApn(params) {
      try {
        this.waiting = true
        await this.loginApn({
          token: params.token,
          operator: params.operator ? params.operator : null
        })
        localStorage.setItem('login', 'normal')
      } catch (e) {
        this.enrichment = false
      } finally {
        this.waiting = false
      }
    },
    async doUnsubscribe() {
      try {
        this.waiting = true
        await this.unsubscribeAuto()
        this.cancelado = true
      } catch (e) {
        this.addAlert({ text: e.response.data, color: 'error' })
      }
      this.waiting = false
    },
    async doUnsubscribeMsisdn() {
      try {
        this.waiting = true
        await this.unsubscribe({ operationId: this.operationId, correlationId: this.correlationId })
        this.cancelado = true
      } catch (e) {
        this.addAlert({ text: e.response.data, color: 'error' })
      }
      this.waiting = false
    }
  }
}
</script>
